const instructions = [
    "Welcome to Simon Says, in this game you will be presented with the last button in a sequence of button presses. Your task is to remember the sequence and repeat it back to advance to the next level. Each level will add another button to the end of the sequence. Good luck!",
];

export default instructions;
